import { Link } from "react-router-dom";
import { phoneIcon } from "../../shared/assets/svg/footer/phoneIcon";
import { Stack } from "../../shared/ui/Stack/Stack";
import { Text } from "../../shared/ui/Text/Text";
import styles from './Footer.module.scss'
import { telegramIcon } from "../../shared/assets/svg/footer/telegramIcon";
import { vkIcon } from "../../shared/assets/svg/footer/vkIcon";
import iconMax from "../../shared/assets/photo/maxlogo.png"

const Footer = () => {
    return ( 
        <footer>
            <Stack 
            direction='column'
            gap = '32'
            className = {styles.container}>
                <Stack
                    justifyContent = 'justifyCenter'  
                    alignItems='alignCenter'
                    gap = '16'
                    className = {styles.icons}
                >
                <Link to="tel:+79283996411">
                        {phoneIcon()}
                </Link>
                <Link to="https://max.ru/u/f9LHodD0cOI5Hde4nVzBWMTOd24Lp2829wyKqCSELvk3Zr-eLR87qK4HhAs" target="_blank">
                        <img className={styles.link} src={iconMax} alt="макс"/>
                </Link>
                <Link to = "https://t.me/+79283996411" target="_blank">
                        {telegramIcon()}
                </Link>
                <Link to = "https://vk.com/id17296526" target="_blank">
                        {vkIcon()}
                </Link>
                </Stack>

                <Stack
                    justifyContent = 'justifyCenter'
                    gap='32'   
                    className={styles.tel__content}
            >
                <Text size='m' className = {styles.text}>
                    г. Ставрополь
                </Text>
                <Text size='m' className = {styles.tel}>
                    +79283996411
                </Text>
                </Stack>

                <Text size='s' className = {styles.copyright}>
                © 2024 Елена Ковешникова. Все права защищены
                </Text>
            </Stack>
        </footer>
     );
}
 
export default Footer;